import {z} from 'zod';

import {optionalHexColour, optionalText} from './catalogueUi';
import {optionalMoneyInput, priceInput} from './moneyInput';

export const colourSchema = z.object({
  name: z.string().min(1),
  kind: optionalText,
  factoryCode: optionalText,
  hex: optionalHexColour,
  priceNet: priceInput,
  costNet: optionalMoneyInput,
  trimIds: z.array(z.string()),
});
